import React from "react";
import moment from "moment-timezone";
import { Box } from "@mui/material";
// import { Button } from "@mui/material";
// import { Mail } from "lucide-react";
import styles from "./retreatDashboardChrome.module.scss";

export function ManageRetreatHeader({
  isSuperAdmin,
  showRosterSelect,
  accessedRetreats,
  onOpenPasswordModal,
}: {
  isSuperAdmin: boolean;
  showRosterSelect: boolean;
  accessedRetreats: any[];
  onOpenPasswordModal: () => void;
}) {
  void isSuperAdmin;
  void onOpenPasswordModal;

  return (
    <header className={styles.header}>
      <p className={styles.eyebrow}>Executive Committee workspace</p>
      <h1 className={styles.title}>Retreat Management Dashboard</h1>
      <p className={styles.description}>
        Monitor active registration, Setup readiness, closing work, and the
        future-retreat planning horizon.
      </p>
      {showRosterSelect && accessedRetreats.length ? (
        <Box
          component="select"
          className="form-select retreatSelect form-select-lg mb-0"
          defaultValue=""
          aria-label="Select retreat roster"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const nextId = e.target.value;
            if (nextId) {
              window.open(`/retreatRoster?retreatId=${nextId}`, "_blank");
            }
            e.currentTarget.value = "";
          }}
          sx={{
            mt: 1.5,
            width: { xs: "100%", sm: "auto" },
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <option value="" disabled>
            Open retreat roster
          </option>
          {accessedRetreats.map((item: any) => (
            <option key={item.id} value={item.id} className="retreatOptions">
              {`${String(item?.title || "").slice(0, 30)}${
                String(item?.title || "").length > 30 ? "..." : ""
              } ${
                item?.dateFrom
                  ? moment(item.dateFrom).tz("America/New_York").format("MMM DD")
                  : ""
              }${
                item?.dateTo
                  ? " - " +
                    moment(item.dateTo).tz("America/New_York").format("MMM DD") +
                    ", " +
                    moment(item.dateFrom).tz("America/New_York").format("YYYY")
                  : ""
              }`}
            </option>
          ))}
        </Box>
      ) : null}
      {/* {isSuperAdmin && (
        <Button
          variant="outlined"
          startIcon={<Mail size={16} />}
          onClick={onOpenPasswordModal}
          sx={{
            width: { xs: "100%", sm: "auto" },
            alignSelf: { sm: "flex-end" },
            whiteSpace: "nowrap",
            textAlign: "left",
            lineHeight: 1.3,
            py: { xs: 1, sm: 0.75 },
          }}
        >
          <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
            Send Password for New Retreat Registration
          </Box>
          <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
            Send Registration Password
          </Box>
        </Button>
      )} */}
    </header>
  );
}
